import React, { useState, useCallback, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import { SlideUpTransition } from '../../Transitions/Transitions';
import BaseDialog from '../BaseDialog';
import { InvoiceHelpType } from '../../../Enums/invoices';

import CouponHelp from '../../../Assets/images/efg/invoice_coupon_help_efg_v2.png';
import ContractHelp from '../../../Assets/images/efg/invoice_contract_help_efg_v2.png';
import InvoiceNumberHelp from '../../../Assets/images/efg/numero_estado_cuenta_factura_efigas_helper.png';

const HelpImage = {
  [InvoiceHelpType.Contract]: ContractHelp,
  [InvoiceHelpType.Coupon]: CouponHelp,
  [InvoiceHelpType.Invoice]: InvoiceNumberHelp
};

function InvoiceHelpDialogEFG(props) {
  const { open = true, onClose, type, title = 'Título' } = props;
  const classes = useStyles();

  const [loading, setLoading] = useState(true);
  const [image, setImage] = useState('');

  const onImageLoaded = useCallback(() => {
    setLoading(false);
  }, []);

  useEffect(() => {
    setLoading(true);
  }, [type]);

  useEffect(() => {
    setImage(HelpImage[type]);
  }, [type]);

  const renderContent = () => {
    return (
      <>
        <img
          className={classes.image}
          src={image}
          alt={`${type} help`}
          onLoad={onImageLoaded}
        />
      </>
    );
  };

  const isMobileSize = useMediaQuery(theme => theme.breakpoints.down('xs'));
  return (
    <BaseDialog
      open={open}
      loading={loading}
      handleClose={onClose}
      title={title}
      actions={() => null}
      content={renderContent}
      fullScreen={isMobileSize}
      TransitionComponent={isMobileSize ? SlideUpTransition : undefined}
      contentStyle={classes.contentStyle}
      paperClass={classes.paperClass}
      titleTextStyle={classes.titleTextStyle}
      maxWidth="sm"
    />
  );
}

const useStyles = makeStyles(theme => ({
  image: {
    width: 348,
    height: 500,
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  contentStyle: {
    padding: theme.spacing(1.25),
    justifyContent: 'center',
    display: 'flex'
  },
  titleTextStyle: {
    textWrap: 'wrap'
  },
  paperClass: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: 380
    }
  }
}));

export default InvoiceHelpDialogEFG;
